"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

const GA_TRACKING_ID = "G-81H299KNCV";
const YM_COUNTER_ID = "105470744";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    ym?: (counterId: string | number, command: string, ...args: unknown[]) => void;
  }
}

export function RouteTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = pathname + (searchParams.toString() ? "?" + searchParams.toString() : "");

    if (typeof window.gtag === "function") {
      window.gtag("config", GA_TRACKING_ID, {
        page_path: url,
      });
    }

    if (typeof window.ym === "function") {
      window.ym(YM_COUNTER_ID, "hit", url);
    }
  }, [pathname, searchParams]);

  return null;
}
